import {
	// Stock Locations
	GET_ALL_STOCK_LOCATIONS,
	GET_ALL_STOCK_LOCATIONS_SUCCESS,
	GET_STOCK_LOCATION,
	GET_STOCK_LOCATION_SUCCESS,
	ADD_STOCK_LOCATION,
	ADD_STOCK_LOCATION_SUCCESS,
	UPDATE_STOCK_LOCATION,
	UPDATE_STOCK_LOCATION_SUCCESS,
	DELETE_STOCK_LOCATION,
	DELETE_STOCK_LOCATION_SUCCESS,
	// Units of Measurement
	GET_ALL_UNITS_OF_MEASUREMENT,
	GET_ALL_UNITS_OF_MEASUREMENT_SUCCESS,
	GET_UNIT_OF_MEASUREMENT,
	GET_UNIT_OF_MEASUREMENT_SUCCESS,
	ADD_UNIT_OF_MEASUREMENT,
	ADD_UNIT_OF_MEASUREMENT_SUCCESS,
	UPDATE_UNIT_OF_MEASUREMENT,
	UPDATE_UNIT_OF_MEASUREMENT_SUCCESS,
	DELETE_UNIT_OF_MEASUREMENT,
	DELETE_UNIT_OF_MEASUREMENT_SUCCESS,
	// Conversions
	GET_ALL_CONVERSIONS,
	GET_ALL_CONVERSIONS_SUCCESS,
	GET_CONVERSION,
	GET_CONVERSION_SUCCESS,
	ADD_CONVERSION,
	ADD_CONVERSION_SUCCESS,
	UPDATE_CONVERSION,
	UPDATE_CONVERSION_SUCCESS,
	DELETE_CONVERSION,
	DELETE_CONVERSION_SUCCESS,
	// Tax Rates
	GET_ALL_TAX_RATES,
	GET_ALL_TAX_RATES_SUCCESS,
	GET_TAX_RATE,
	GET_TAX_RATE_SUCCESS,
	ADD_TAX_RATE,
	ADD_TAX_RATE_SUCCESS,
	UPDATE_TAX_RATE,
	UPDATE_TAX_RATE_SUCCESS,
	DELETE_TAX_RATE,
	DELETE_TAX_RATE_SUCCESS,
	// Payment Methods
	GET_ALL_PAYMENT_METHODS,
	GET_ALL_PAYMENT_METHODS_SUCCESS,
	GET_PAYMENT_METHOD,
	GET_PAYMENT_METHOD_SUCCESS,
	ADD_PAYMENT_METHOD,
	ADD_PAYMENT_METHOD_SUCCESS,
	UPDATE_PAYMENT_METHOD,
	UPDATE_PAYMENT_METHOD_SUCCESS,
	DELETE_PAYMENT_METHOD,
	DELETE_PAYMENT_METHOD_SUCCESS,
	// Payment Bills
	GET_ALL_PAYMENT_BILLS,
	GET_ALL_PAYMENT_BILLS_SUCCESS,
	GET_PAYMENT_BILL,
	GET_PAYMENT_BILL_SUCCESS,
	ADD_PAYMENT_BILL,
	ADD_PAYMENT_BILL_SUCCESS,
	UPDATE_PAYMENT_BILL,
	UPDATE_PAYMENT_BILL_SUCCESS,
	DELETE_PAYMENT_BILL,
	DELETE_PAYMENT_BILL_SUCCESS,
	GET_ALL_VOID_REASONS,
	GET_ALL_VOID_REASONS_SUCCESS,
	GET_VOID_REASON,
	GET_VOID_REASON_SUCCESS,
	ADD_VOID_REASON,
	ADD_VOID_REASON_SUCCESS,
	UPDATE_VOID_REASON,
	UPDATE_VOID_REASON_SUCCESS,
	DELETE_VOID_REASON,
	DELETE_VOID_REASON_SUCCESS,
	GET_ALL_REFUND_REASONS,
	GET_ALL_REFUND_REASONS_SUCCESS,
	GET_REFUND_REASON,
	GET_REFUND_REASON_SUCCESS,
	ADD_REFUND_REASON,
	ADD_REFUND_REASON_SUCCESS,
	UPDATE_REFUND_REASON,
	UPDATE_REFUND_REASON_SUCCESS,
	DELETE_REFUND_REASON,
	DELETE_REFUND_REASON_SUCCESS,
} from "../actions/DefaultValues.action";

const initialState = {
	// Stock Locations
	getAllStockLocationsLoading: false,
	getStockLocationLoading: false,
	addStockLocationLoading: false,
	updateStockLocationLoading: false,
	deleteStockLocationLoading: false,
	stockLocations: [],
	stockLocation: null,
	// Units of Measurement
	getAllUnitsOfMeasurementLoading: false,
	getUnitOfMeasurementLoading: false,
	addUnitOfMeasurementLoading: false,
	updateUnitOfMeasurementLoading: false,
	deleteUnitOfMeasurementLoading: false,
	unitsOfMeasurement: [],
	unitOfMeasurement: null,
	// Conversions
	getAllConversionsLoading: false,
	getConversionLoading: false,
	addConversionLoading: false,
	updateConversionLoading: false,
	deleteConversionLoading: false,
	conversions: [],
	conversion: null,
	// Tax Rates
	getAllTaxRatesLoading: false,
	getTaxRateLoading: false,
	addTaxRateLoading: false,
	updateTaxRateLoading: false,
	deleteTaxRateLoading: false,
	taxRates: [],
	taxRate: null,
	// Payment Methods
	getAllPaymentMethodsLoading: false,
	getPaymentMethodLoading: false,
	addPaymentMethodLoading: false,
	updatePaymentMethodLoading: false,
	deletePaymentMethodLoading: false,
	paymentMethods: [],
	paymentMethod: null,
	// Payment Bills
	getAllPaymentBillsLoading: false,
	getPaymentBillLoading: false,
	addPaymentBillLoading: false,
	updatePaymentBillLoading: false,
	deletePaymentBillLoading: false,
	paymentBills: [],
	paymentBill: null,
	// Void Reasons
	getAllVoidReasonsLoading: false,
	getVoidReasonLoading: false,
	addVoidReasonLoading: false,
	updateVoidReasonLoading: false,
	deleteVoidReasonLoading: false,
	voidReasons: [],
	voidReason: null,
	// Refund Reasons
	getAllRefundReasonsLoading: false,
	getRefundReasonLoading: false,
	addRefundReasonLoading: false,
	updateRefundReasonLoading: false,
	deleteRefundReasonLoading: false,
	refundReasons: [],
	refundReason: null,
};

function defaultValues(state = initialState, action) {
	switch (action.type) {
		// Stock Locations
		case GET_ALL_STOCK_LOCATIONS:
			return Object.assign({}, state, action.payload);
		case GET_ALL_STOCK_LOCATIONS_SUCCESS:
			return Object.assign({}, state, {
				stockLocations: action.payload.stockLocations,
			});
		case GET_STOCK_LOCATION:
			return Object.assign({}, state, action.payload);
		case GET_STOCK_LOCATION_SUCCESS:
			return Object.assign({}, state, {
				stockLocation: action.payload.stockLocation,
			});
		case ADD_STOCK_LOCATION:
			return Object.assign({}, state, action.payload);
		case ADD_STOCK_LOCATION_SUCCESS:
			return Object.assign({}, state, {
				stockLocations: action.payload.stockLocations,
			});
		case UPDATE_STOCK_LOCATION:
			return Object.assign({}, state, action.payload);
		case UPDATE_STOCK_LOCATION_SUCCESS:
			return Object.assign({}, state, {
				stockLocations: action.payload.stockLocations,
			});
		case DELETE_STOCK_LOCATION:
			return Object.assign({}, state, action.payload);
		case DELETE_STOCK_LOCATION_SUCCESS:
			return Object.assign({}, state, {
				stockLocations: action.payload.stockLocations,
			});
		// Units of Measurement
		case GET_ALL_UNITS_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case GET_ALL_UNITS_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitsOfMeasurement: action.payload.unitsOfMeasurement,
			});
		case GET_UNIT_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case GET_UNIT_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitOfMeasurement: action.payload.unitOfMeasurement,
			});
		case ADD_UNIT_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case ADD_UNIT_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitsOfMeasurement: action.payload.unitsOfMeasurement,
			});
		case UPDATE_UNIT_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case UPDATE_UNIT_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitsOfMeasurement: action.payload.unitsOfMeasurement,
			});
		case DELETE_UNIT_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case DELETE_UNIT_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitsOfMeasurement: action.payload.unitsOfMeasurement,
			});
		// Conversions
		case GET_ALL_CONVERSIONS:
			return Object.assign({}, state, action.payload);
		case GET_ALL_CONVERSIONS_SUCCESS:
			return Object.assign({}, state, {
				conversions: action.payload.conversions,
			});
		case GET_CONVERSION:
			return Object.assign({}, state, action.payload);
		case GET_CONVERSION_SUCCESS:
			return Object.assign({}, state, {
				conversion: action.payload.conversion,
			});
		case ADD_CONVERSION:
			return Object.assign({}, state, action.payload);
		case ADD_CONVERSION_SUCCESS:
			return Object.assign({}, state, {
				conversions: action.payload.conversions,
			});
		case UPDATE_CONVERSION:
			return Object.assign({}, state, action.payload);
		case UPDATE_CONVERSION_SUCCESS:
			return Object.assign({}, state, {
				conversions: action.payload.conversions,
			});
		case DELETE_CONVERSION:
			return Object.assign({}, state, action.payload);
		case DELETE_CONVERSION_SUCCESS:
			return Object.assign({}, state, {
				conversions: action.payload.conversions,
			});
		// Tax Rates
		case GET_ALL_TAX_RATES:
			return Object.assign({}, state, action.payload);
		case GET_ALL_TAX_RATES_SUCCESS:
			return Object.assign({}, state, {
				taxRates: action.payload.taxRates,
			});
		case GET_TAX_RATE:
			return Object.assign({}, state, action.payload);
		case GET_TAX_RATE_SUCCESS:
			return Object.assign({}, state, {
				taxRate: action.payload.taxRate,
			});
		case ADD_TAX_RATE:
			return Object.assign({}, state, action.payload);
		case ADD_TAX_RATE_SUCCESS:
			return Object.assign({}, state, {
				taxRates: action.payload.taxRates,
			});
		case UPDATE_TAX_RATE:
			return Object.assign({}, state, action.payload);
		case UPDATE_TAX_RATE_SUCCESS:
			return Object.assign({}, state, {
				taxRates: action.payload.taxRates,
			});
		case DELETE_TAX_RATE:
			return Object.assign({}, state, action.payload);
		case DELETE_TAX_RATE_SUCCESS:
			return Object.assign({}, state, {
				taxRates: action.payload.taxRates,
			});
		// Payment Methods
		case GET_ALL_PAYMENT_METHODS:
			return Object.assign({}, state, action.payload);
		case GET_ALL_PAYMENT_METHODS_SUCCESS:
			return Object.assign({}, state, {
				paymentMethods: action.payload.paymentMethods,
			});
		case GET_PAYMENT_METHOD:
			return Object.assign({}, state, action.payload);
		case GET_PAYMENT_METHOD_SUCCESS:
			return Object.assign({}, state, {
				paymentMethod: action.payload.paymentMethod,
			});
		case ADD_PAYMENT_METHOD:
			return Object.assign({}, state, action.payload);
		case ADD_PAYMENT_METHOD_SUCCESS:
			return Object.assign({}, state, {
				paymentMethods: action.payload.paymentMethods,
			});
		case UPDATE_PAYMENT_METHOD:
			return Object.assign({}, state, action.payload);
		case UPDATE_PAYMENT_METHOD_SUCCESS:
			return Object.assign({}, state, {
				paymentMethods: action.payload.paymentMethods,
			});
		case DELETE_PAYMENT_METHOD:
			return Object.assign({}, state, action.payload);
		case DELETE_PAYMENT_METHOD_SUCCESS:
			return Object.assign({}, state, {
				paymentMethods: action.payload.paymentMethods,
			});
		// Payment Bills
		case GET_ALL_PAYMENT_BILLS:
			return Object.assign({}, state, action.payload);
		case GET_ALL_PAYMENT_BILLS_SUCCESS:
			return Object.assign({}, state, {
				paymentBills: action.payload.paymentBills,
			});
		case GET_PAYMENT_BILL:
			return Object.assign({}, state, action.payload);
		case GET_PAYMENT_BILL_SUCCESS:
			return Object.assign({}, state, {
				paymentBill: action.payload.paymentBill,
			});
		case ADD_PAYMENT_BILL:
			return Object.assign({}, state, action.payload);
		case ADD_PAYMENT_BILL_SUCCESS:
			return Object.assign({}, state, {
				paymentBills: action.payload.paymentBills,
			});
		case UPDATE_PAYMENT_BILL:
			return Object.assign({}, state, action.payload);
		case UPDATE_PAYMENT_BILL_SUCCESS:
			return Object.assign({}, state, {
				paymentBills: action.payload.paymentBills,
			});
		case DELETE_PAYMENT_BILL:
			return Object.assign({}, state, action.payload);
		case DELETE_PAYMENT_BILL_SUCCESS:
			return Object.assign({}, state, {
				paymentBills: action.payload.paymentBills,
			});
		// Void Reasons
		case GET_ALL_VOID_REASONS:
			return Object.assign({}, state, action.payload);
		case GET_ALL_VOID_REASONS_SUCCESS:
			return Object.assign({}, state, {
				voidReasons: action.payload.voidReasons,
			});
		case GET_VOID_REASON:
			return Object.assign({}, state, action.payload);
		case GET_VOID_REASON_SUCCESS:
			return Object.assign({}, state, {
				voidReason: action.payload.voidReason,
			});
		case ADD_VOID_REASON:
			return Object.assign({}, state, action.payload);
		case ADD_VOID_REASON_SUCCESS:
			return Object.assign({}, state, {
				voidReasons: action.payload.voidReasons,
			});
		case UPDATE_VOID_REASON:
			return Object.assign({}, state, action.payload);
		case UPDATE_VOID_REASON_SUCCESS:
			return Object.assign({}, state, {
				voidReasons: action.payload.voidReasons,
			});
		case DELETE_VOID_REASON:
			return Object.assign({}, state, action.payload);
		case DELETE_VOID_REASON_SUCCESS:
			return Object.assign({}, state, {
				voidReasons: action.payload.voidReasons,
			});
		// Refund Reasons
		case GET_ALL_REFUND_REASONS:
			return Object.assign({}, state, action.payload);
		case GET_ALL_REFUND_REASONS_SUCCESS:
			return Object.assign({}, state, {
				refundReasons: action.payload.refundReasons,
			});
		case GET_REFUND_REASON:
			return Object.assign({}, state, action.payload);
		case GET_REFUND_REASON_SUCCESS:
			return Object.assign({}, state, {
				refundReason: action.payload.refundReason,
			});
		case ADD_REFUND_REASON:
			return Object.assign({}, state, action.payload);
		case ADD_REFUND_REASON_SUCCESS:
			return Object.assign({}, state, {
				refundReasons: action.payload.refundReasons,
			});
		case UPDATE_REFUND_REASON:
			return Object.assign({}, state, action.payload);
		case UPDATE_REFUND_REASON_SUCCESS:
			return Object.assign({}, state, {
				refundReasons: action.payload.refundReasons,
			});
		case DELETE_REFUND_REASON:
			return Object.assign({}, state, action.payload);
		case DELETE_REFUND_REASON_SUCCESS:
			return Object.assign({}, state, {
				refundReasons: action.payload.refundReasons,
			});
		default:
			return state;
	}
}

export default defaultValues;

